<div class="wrapper">
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    animationDuration="0ms"
  >
    <div class="title">Возраст</div>
    <mat-tab label="Все">
      <div class="tab-content">
        <app-form-with-ranges
          [title]="'Возраст'"
          [params]="prepareFormParamsForAgeTab('all')"
          [isEditEnabled]="isEditEnabled()"
          (formRangeChanged)="handleAgeFormRangeChange($event, 'all')"
        />
      </div>
    </mat-tab>
    <mat-tab label="Мужчины">
      <div class="tab-content">
        <app-form-with-ranges
          [title]="'Возраст'"
          [params]="prepareFormParamsForAgeTab('men')"
          [isEditEnabled]="isEditEnabled()"
          (formRangeChanged)="handleAgeFormRangeChange($event, 'men')"
        />
      </div>
    </mat-tab>
    <mat-tab label="Женщины">
      <div class="tab-content">
        <app-form-with-ranges
          [title]="'Возраст'"
          [params]="prepareFormParamsForAgeTab('women')"
          [isEditEnabled]="isEditEnabled()"
          (formRangeChanged)="handleAgeFormRangeChange($event, 'women')"
        />
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

